import "../css/Team.css";
import TeamCard from "../components/TeamCard";
import ajiboye from "../assets/team/ajiboye.png";
import saad from "../assets/team/saad.png";
import bill from "../assets/team/bill.png";
import lamar from "../assets/team/lamar.png";
import nancy from "../assets/team/nancy.png";
import kartherine from "../assets/team/katherine.png";
import jackson from "../assets/team/jackson.png";
import joshua from "../assets/team/joshua.png";
import zahra from "../assets/team/zahra.png";

const member = [
    {
        title: "Ajiboye Bello",
        occupation: "",
        content:
            "Ajiboye holds a B.Sc. in Civil and Environmental Engineering from the University of Lagos, Nigeria, and an M.Sc. in Advanced Structural Analysis and Design Using Composite Materials (FRP++) through the Erasmus Mundus Master’s Program. Before his M.Sc., he gained nine years of industry experience as a Graduate Engineer. He is currently pursuing a Ph.D. with a research focus on the behavior of GFRP bars subjected to abrasive blasting impact under the supervision of Professor Marianna Polak and Professor Kunho Eugene Kim. Beyond academia, he enjoys playing football.",
        email: "a2bello@uwaterloo.ca",
        image: ajiboye,
    },
    {
        title: "Saad Saad",
        content:
            "I joined Professor Polak’s research team as a Postdoctoral Fellow in June 2024. I am currently investigating the behavior of Glass Fiber Reinforced Polymer (GFRP) reinforcedconcrete frame joints subject to opening and closing moments using finite elementmodelling with the objective of proposing relevant design and detailing recommendations. During my PhD research, I studied the effects of climate change on concrete bridge decks with particular interest in thermal effects and thermal loads.",
        email: "",
        linkedin: "https://www.linkedin.com/in/saad-saad-531521179/",
        website: "https://orcid.org/0009-0009-4906-8771",
        image: saad,
    },
    {
        title: "Bill Deng",
        content:
            "I received my BASc. For Civil Engineering from the University of Waterloo in 2024. My research focuses on analyzing the bond behaviour of GFRP in concrete.",
        email: "q34deng@uwaterloo.ca",
        linkedin: "https://www.linkedin.com/in/bill-deng-4026721a7/",
        image: bill,
    },
    {
        title: "Lamar Bashbishi",
        content:
            "Hi! My name is Lamar and I graduated from civil engineering at the University of Waterloo in 2022. I decided to pursue a masters because who doesn&#39;t love concrete? Okay...maybe not everyone. My research focused on FRP-reinforced concrete corner joints and the best practices for designing with FRP in regions of low development length. My research involved a lot of lab work: gluing strain gauges, building rebar cages, casting concrete, etc. In my free time I like to read, listen to music and hang out with my friends/cousins. Fun fact, I taught myself how to read Korean, and now I&#39;m trying to learn Japanese!",
        email: "lbashbishi@uwaterloo.ca",
        image: lamar,
    },
    {
        title: "Nancy Kachouh",
        content:
            "I joined the Civil and Environmental Engineering Department at the University of Waterloo as a Phd student in May 2024. Her research is on the topic of the behavior and design of concrete slabs reinforced with glass fiber reinforced polymer (GFRP) bar with special consideration of avoiding punching shear failures of such systems. Her work includes experimental and numerical investigations. Before joining Waterloo, Nancy published seven articles in international journals. She also received the American Concrete Institute (ACI) Middle East Fellowship for the 2019-2020 academic year.",
        email: "n2kachou@uwaterloo.ca",
        image: nancy,
    },
    {
        title: "Katherine Liu",
        content:
            "I am Katherine Liu, a PhD candidate in Professor Polak’s research group. I amcurrently working on testing and analyzing hybrid (GFRP and steel rebar) reinforced beam-column joints in seismic environments. I used to work on developing a strut-tie method that works for FRP-reinforced deep sections. Outside of the research work, I like anime and video games (RPG). Here is a picture of the frame that will be used to test my beam-column joint specimens.”",
        image: kartherine,
    },
    {
        title: "Jackson Davey",
        content:
            "Jackson is a graduate student undertaking a Master of Applied Science degree in Civil Engineering. His thesis is on the punching shear behaviour of flat concrete slabs with GFRP flexural reinforcement, where he will be running laboratory tests comparing the behaviour of steel and GFRP reinforced slabs, as well as GFRP slabs with and without shear reinforcement. Outside of school, Jackson enjoys exploring music. Some of his favourite bands are Metallica, Headstones, and Judas Priest. Jackson also enjoys fantasy settings such as Star Wars, Warhammer, and the Forgotten Realms, among others.”",
        email: "jackson.davey@uwaterloo.ca",
        image: jackson,
    },
    {
        title: "Joshua Ayande",
        content:
            "I am a PhD student in civil and environmental engineering with research interests in Fibre Reinforced Polymers (FRPs), probabilistic modeling of structural behavior, and the structural performance of reinforced concrete systems. My current work focuses on the reliability-based calibration of design formulas in the new Canadian codes for GFRP-reinforced concrete. The goal is to establish rational safety factors to support the safe and efficient use of advanced materials in structural design.”",
        email: "Ayande.joshua@yahoo.com",
        image: joshua,
    },
    {
        title: "Zahra (Leila) Miri",
        content:
            "Zahra (Leila) Miri is a Ph.D. candidate in Civil and Environmental Engineering at the University of Waterloo, co-supervised by Professors Marianna Polak and Hassan Baaj. Her research focuses on 3D concrete printing, specifically the mechanical characterization of interlayer bonding using experimental testing and finite element modeling. She also has experience in non-destructive ultrasonic testing and digital image correlation for studying interlayer behavior. Leila is passionate about teaching and mentoring students. Beyond academia, she enjoys cooking, photography, and working with clay on the pottery wheel.”",
        email: "",
        image: zahra,
    },
];

function Team() {
    return (
        <div className="team-main">
            <div className="team-main-container">
                <h1 className="title">Current Members</h1>
                <hr className="seperator"></hr>
                <TeamCard member={member}></TeamCard>
            </div>
        </div>
    );
}
export default Team;
